const Index = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/RelatorioFinanceiro/Index')

export default [
  {
    path: 'relatorio-financeiro',
    name: 'RelatorioFinanceiro',
    component: Index,
    meta: {
      title: 'Relatório Financeiro',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'relatorioFinanceiro',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/relatorio-financeiro.js